import { render } from "./BaseTextBox.vue?vue&type=template&id=1e12bec4&scoped=true"
import script from "./BaseTextBox.vue?vue&type=script&lang=js"
export * from "./BaseTextBox.vue?vue&type=script&lang=js"

import "./BaseTextBox.vue?vue&type=style&index=0&id=1e12bec4&lang=scss&scoped=true"

import exportComponent from "/builds/strooka-jagaad/strooka-fe/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e12bec4"]])

export default __exports__